<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>

  <form
    @submit.prevent="store"
    class="form-content w-full h-full max-w-lg px-1"
  >
    <div class="mt-3 mx-3">
      <div class="flex flex-wrap -mx-3 mb-1">
        <field
          :label="$t('attachment.file_1')"
          class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
        >
          <input
            type="file"
            accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
            v-on:change="onFileChangeDoc($event)"
            class="form-control-file"
            id="my-file"
          />
        </field>
      </div>

      <div class="border p-2 mt-3 mb-6">
        <p>Preview Here:</p>
        <div v-if="isImage">
          <img :src="preview" class="img-fluid" />
          <p class="mb-0">file name: {{ image.name }}</p>
          <p class="mb-0">
            size:
            {{
              Math.ceil(image.size / 1024) > 0
                ? Math.ceil(image.size / 1024)
                : 0
            }}KB
          </p>
        </div>

        <div v-else>
          <img
            v-if="attachment.file_1"
            :src="attachment2.url_file"
            class="img-fluid"
          />
          <p v-if="attachment.file_1" class="mb-0">
            file name: {{ attachment2.name_file }}
          </p>
          <p v-if="attachment.file_1" class="mb-0">
            size:
            {{
              Math.ceil(attachment2.size_file / 1024) > 0
                ? Math.ceil(attachment2.size_file / 1024)
                : 0
            }}KB
          </p>
        </div>
      </div>
    </div>
    <jb-buttons>
      <jb-button type="submit" color="info" label="Submit" class="m-3" />
      <jb-button type="reset" color="info" outline label="Reset" />
    </jb-buttons>
  </form>

  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>
</template>
<script>
/* eslint-disable */
import {
  ref,
  reactive,
  onMounted,
  onBeforeMount,
  watch,
  watchEffect,
} from "vue";
import axios from "axios";
import { axiosDocument } from "@/boot/axios";
import { useStore } from "vuex";
import { mdiBallot, mdiPlusCircleOutline, mdiClose } from "@mdi/js";
import JbButton from "@/components/JbButton";
import JbButtons from "@/components/JbButtons";
import Field from "@/components/Field";
import { useToast } from "vue-toastification";
import { getUserData } from "@/composables/global";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "ClassForm",
  components: {
    Field,
    JbButton,
    JbButtons,
    Loading,
  },
  props: {
    showEdit: { type: Boolean },
    propClassid: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propAttach: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propComboards: {
      type: Object,
      default: () => ({ empty: true }),
    },
  },
  data: function () {
    return {};
  },
  emits: ["close-modal", "click-refresh-from", "submit"],
  setup(props, { emit }) {
    const isLoading = ref(false);
    const titleStack = ref(["Admin", "Forms"]);
    const preview = ref("");
    const image = ref([]);
    const { userList } = getUserData();
    const toast = useToast();
    const errors = ref([]);
    const str = useStore();
    const attachment = reactive({
      id: "",
      comboard_id: "",
      file_1: "",
      file_name: "",
      title: "",
    });
    const attachment2 = reactive({
      id: "",
      comboard_id: "",
      doc_file_id: "",
      file_1: "",
      url_file: "",
      name_file: "",
      size_file: "",
    });
    const userlogin = localStorage.getItem("name");

    const validMimeTypes = [
      "application/pdf", // PDF

      // Excel
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx

      "text/csv", // CSV

      // Word
      "application/msword", // .doc
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx

      // PowerPoint
      "application/vnd.ms-powerpoint", // .ppt
      "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx

      // Images
      "image/jpeg", // JPEG
      "image/png", // PNG
      "image/gif", // GIF
      "image/bmp", // BMP
      "image/webp", // WebP
    ];


    const imageMimeTypes = [
      // Images
      "image/jpeg", // JPEG
      "image/png", // PNG
      "image/gif", // GIF
      "image/bmp", // BMP
      "image/webp", // WebP
    ];

    const isImage = ref(false)

    const onFileChange = async (event) => {
      const file = event.target.files[0];
      if (file) {
        if (file.size > 51200 * 51200) {
          alert("File too big (> 50MB)");
          const es = document.forms[1].elements;
          es[0].value = "";
          document.getElementById("my-file").value = null;
        } else {
          const reader = new FileReader();
          reader.onloadend = function () {
            preview.value = reader.result;
          };
          image.value = file;
          reader.readAsDataURL(file);
        }
      } else {
        preview.value = "";
        image.value = [];
      }
    };

    const uploadStudent = reactive({
      comboard_id: "",
      file_name: [],
      file_jdl: [],
      doc_cat_id: [],
      doc_cat_name: "",
      data_full: [],
      title: "",
      created_by: userlogin,
    });

    const file_name = ref("");
    const onFileChangeDoc = async (event) => {
      const resetPreview = () => {
        file.value = "";
      };
      const file = event.target.files;

      for (let x = 0; x < file.length; x++) {
        // Validate MIME type
        if (!validMimeTypes.includes(file[x].type)) {
          alert(
            `File ${file[x].name} is not a valid type. Supported types: PDF, Excel, CSV, Word, PowerPoint, and Images.`
          );
          const es = document.forms[x].elements;
          es[0].value = "";
          document.getElementById("my-file").value = null;
          resetPreview();
          continue; // Skip invalid files
        }
        const sizeInMB = (file[x].size / (1024 * 1024)).toFixed(2);
        console.log('MaxSizeInMB', MaxUploadLimit.value)
        console.log('sizeInMB',sizeInMB)
        // if (!file[x].value) continue; ;
        if (parseFloat(sizeInMB) > parseFloat(MaxUploadLimit.value)) {
          console.log('lebih besar dari max upo+load')
          alert("File too big ( Max "+ MaxUploadLimit.value+" MB)");
          file[x].value = "";
          const es = document.forms[x].elements;
          es[0].value = "";

          document.getElementById("my-file").value = null;
          resetPreview();
          continue; // Skip large files
        }
        const reader = new FileReader();
        file_name.value = file[x].name;
        // uploadStudent.file_name.push(file)
        reader.readAsDataURL(file[x]);
        reader.onloadend = function () {
          if (imageMimeTypes.includes(file[x].type)) {
            isImage.value = true
          }
          preview.value = reader.result;
          // uploadStudent.file_name[i] = preview.value
          // uploadStudent.file_jdl[i] = file[x].name
          uploadStudent.file_name.push(preview.value);
          uploadStudent.file_jdl.push(file[x].name);

          uploadStudent.data_full.push({
            doc_cat_id: "fc989a93-70b4-46cd-9285-fe09f3713efa",
            name: file[x].name,
            file_name: preview.value,
          });
        };

        image.value = file[x];
      }
      resetPreview();

    };

    const getBase64 = async (attach) => {
      const params = { id: attach.id };
      await axios
        .get("/image", {
          params: params,
        })
        .then((res) => {
          attachment.file_1 = res.data.img;

          attachment2.url_file = res.data.img;
          attachment2.name_file = res.data.name64;
          attachment2.size_file = res.data.size64;
        });
    };

    const filter = reactive({
      comboard_id: "",
      title: "",
    });

    const store = async () => {
      // (STORE KE API EDU)
      isLoading.value = true;

      attachment.created_by = userlogin;
      attachment.file_1 = preview.value;
      attachment.updated_by = userlogin;
      attachment.comboard_id = attachment2.comboard_id;
      attachment.id = attachment2.id;

      attachment.title = filter.title;

      if (attachment2.name_file !== "") {
        attachment.file_name = attachment2.name_file;
      }
      if (image.value) {
        attachment.file_name = image.value.name;
      }

      const jsonData = JSON.stringify(attachment);

      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      };

      const url = props.showEdit
        ? "comboard-attachment/" + attachment.id
        : "comboard-attachment";
      const method = props.showEdit ? "PUT" : "POST";

      // return true
      // axios.post(url, attachment, config)
      axios({
        method,
        url,
        data: jsonData,
        headers: configHeaders,
      })
        .then((res) => {
          reset();
          emit("close-modal");
          emit("click-refresh-from");
          toast.success(res.data.message);

          isLoading.value = false;
        })
        .catch((error) => {
          storeDoc();
          console.log(error);

          // isLoading.value = false
        });
    };

    const storeDoc = async () => {
      // (STORE KE API DOC-MANAGEMENT(KARNA BISA SEKALIGUS))
      const url = props.showEdit ? "replace-file-comboard" : "store-comboard";
      const method = "POST";
      uploadStudent.comboard_id = filter.comboard_id;
      uploadStudent.title = filter.title;

      if (uploadStudent.file_name.length > 0) {
        for (let i = 0; i < uploadStudent.file_name.length; i++) {
          if (uploadStudent.file_name[i] === "") {
            toast.warning("Make sure the value is filled in");
            return true;
          }
        }
      } else {
        toast.warning("Make sure the value is filled in");
        return true;
      }

      isLoading.value = true;
      const paramsData = {
        comboard_id: uploadStudent.comboard_id,
        title: uploadStudent.title,
        data_full: uploadStudent.data_full,
        created_by: uploadStudent.created_by,
      };
      const editdata = {
        id: attachment2.id,
        id_file: attachment2.doc_file_id,
        type: "",
        status: "replace",
        name: uploadStudent.file_jdl[0],
        base64: uploadStudent.file_name[0],
        title: uploadStudent.title,
        user_id: uploadStudent.comboard_id,
        created_by: uploadStudent.created_by,
      };

      const jsonData = props.showEdit
        ? JSON.stringify(editdata)
        : JSON.stringify(paramsData);

      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      };

      axiosDocument({
        method,
        url,
        data: jsonData,
        headers: configHeaders,
      })
        .then((response) => {
          reset();
          emit("close-modal");
          emit("click-refresh-from");
          isLoading.value = false;
          if (response.data.success === true) {
            toast.success(response.data.message);
          }

          if (response.data.success === false) {
            toast.warning(response.data.message);
          }
        })
        .catch((error) => {
          isLoading.value = false;
          console.log("error", error);
        });
    };

    const MaxUploadLimit = ref(0)
    const getUploadLimit = async () => {
      await axios
        .get("/upload-limit")
        .then((res) => {
          // console.log('MaxUploadLimit',res.data.data)
          MaxUploadLimit.value = res.data.data

        });
    };

    onBeforeMount(() => {
      // refresh()
      getUploadLimit()
    });
    onMounted(() => {});

    watch(
      () => attachment2.comboard_id,
      (newVal, oldVal) => {
        reset();
      }
    );

    watch(
      () => attachment2.id,
      (newVal, oldVal) => {
        reset();

        // const extName = ['png', 'jpg', 'jpeg']
        // if(attachment2.file_1 !== undefined){
        //   var ext = attachment2.file_1.split('.').pop()
        //   if (extName.includes(ext)) {
        //       getBase64(attachment2)
        //   }
        // }
      }
    );

    const reset = () => {
      document.getElementById("my-file").value = null;
      preview.value = "";
      image.value = [];

      uploadStudent.comboard_id = "";
      uploadStudent.file_name = [];
      uploadStudent.file_jdl = [];
      uploadStudent.doc_cat_id = [];
      uploadStudent.doc_cat_name = "";
      uploadStudent.data_full = [];
      uploadStudent.title = "";

      attachment.file_1 = null;
      attachment2.url_file = null;
      attachment2.name_file = null;
      attachment2.size_file = 0;
      // attachment2.doc_file_id = ''
    };

    watchEffect(() => {
      const comboard = props.propAttach;
      const comboardData = props.propComboards;
      Object.assign(attachment2, comboard);
      Object.assign(filter, comboardData);
      // refresh()
    });

    return {
      storeDoc,
      attachment2,
      getBase64,
      reset,
      titleStack,
      mdiBallot,
      mdiPlusCircleOutline,
      mdiClose,
      attachment,
      store,
      str,
      userList,
      toast,
      userlogin,
      image,
      preview,
      file_name,
      onFileChange,
      onFileChangeDoc,
      errors,
      isImage,
      isLoading,
      MaxUploadLimit
    };
  },
  methods: {
    clearForm() {
      this.attachment = reactive({
        id: "",
        comboard_id: "",
        file_1: "",
      });
    },
  },
};
</script>
